<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa m-t-40 private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <v-form
            action
            @submit.prevent="createLaw"
          >
            <div class="form-head">
              <Widget position="menu_profile" />
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                  >
                    {{ $t("Профиль") }} <span class="caret"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <div class="form-col-2">
                <div
                  :class="{ invalid: $v.law.nameKg.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Наименование на государственном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-text-field
                    v-model="law.nameKg"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                  />
                </div>
                <div
                  :class="{ invalid: $v.law.name.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Наименование на официальном языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-text-field
                    v-model="law.name"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                  />
                </div>
                <div
                  :class="{ invalid: $v.law.number.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Номер") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-text-field
                    v-model.number="law.number"
                    type="number"
                    required
                    outlined
                    rounded
                    dense
                    clearable
                  />
                </div>
                <div
                  :class="{ invalid: $v.law.adoptionDate.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Дата принятия") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="form-date">
                    <v-menu
                      v-model="adoptionDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="law.adoptionDate"
                          required
                          readonly
                          v-on="on"
                          outlined
                          rounded
                          dense
                        />
                      </template>
                      <v-date-picker
                        v-model="law.adoptionDate"
                        @input="adoptionDateMenu = false"
                        :weekday-format="getDay"
                        :month-format="getMonthFormat"
                        :header-date-format="getHeaderDateFormat"
                        no-title
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </div>
                </div>
                <div
                  :class="{ invalid: $v.law.effectiveDate.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Дата вступления") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <div class="form-date">
                    <v-menu
                      v-model="effectiveDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="law.effectiveDate"
                          required
                          readonly
                          v-on="on"
                          outlined
                          rounded
                          dense
                        />
                      </template>
                      <v-date-picker
                        v-model="law.effectiveDate"
                        @input="effectiveDateMenu = false"
                        :weekday-format="getDay"
                        :month-format="getMonthFormat"
                        :header-date-format="getHeaderDateFormat"
                        no-title
                        first-day-of-week="1"
                      />
                    </v-menu>
                  </div>
                </div>
                <div
                  :class="{ invalid: $v.law.number.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Вид закона") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-select
                        id="developer"
                        item-value="id"
                        item-text="transName"
                        v-model="law.kindOfLaw"
                        :items="lawData.refKindOfLaw"
                        input="transName"
                        outlined
                        rounded
                        dense
                  ></v-select>
                </div>
                <!-------->
                <div
                  :class="{ invalid: $v.law.number.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Тип закона") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-select
                        id="developer"
                        item-value="id"
                        item-text="transName"
                        v-model="law.lawType"
                        :items="lawData.refLawType"
                        input="transName"
                        outlined
                        rounded
                        dense
                  ></v-select>
                </div>
                <!------->
                <div
                  :class="{ invalid: $v.law.number.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Статус закона") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-select
                        id="developer"
                        item-value="id"
                        item-text="transName"
                        v-model="law.statusInDatabase"
                        :items="lawData.refLawStatus"
                        input="transName"
                        outlined
                        rounded
                        dense
                  ></v-select>
                </div>
                <!------->
                <div
                  :class="{ invalid: $v.law.number.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Исполнение законов") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-select
                        id="developer"
                        item-value="id"
                        item-text="transName"
                        v-model="law.executionOfLaw"
                        :items="lawData.refExecutionOfLaw"
                        input="transName"
                        outlined
                        rounded
                        dense
                  ></v-select>
                </div>
  
              </div>
            </div>
            <div class="form-bottom">
              <div class="form-group form-action">
                <button
                  class="btn btn-default blue"
                  type="submit"
                >
                  {{ $t("Сохранить") }}
                </button>
                <button
                  class="btn btn-default white"
                  @click="onCancel"
                >
                  {{ $t("Отмена") }}
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import LAW from '@/model/law'
import fieldInfo from '@/components/app/fieldInfo'
import Widget from '@/components/app/Widget'
import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapMutations } from 'vuex'
import mixin from '@/plugins/mixin/mixin'
import {Trans} from "@/plugins/Translation"

export default {
  mixins: [mixin],
  components: {
    fieldInfo,
    Widget
  },
  data: () => ({
    valid: true,
    currentuser: null,
    lawData: {},
    law: {
      nameKg: '',
      name: '',
      number: '',
      adoptionDate: '',
      effectiveDate: '',
      test1: '',
      executionOfLaw: null,
      lawType: null,
      kindOfLaw: null,
      statusInDatabase: null,
    },
    adoptionDateMenu: false,
    effectiveDateMenu: false,
    rules: {
      law: {
        nameKg: { required },
        name: { required },
        number: { required },
        adoptionDate: { required },
        effectiveDate: { required }
      }
    },
    breadcrumbs: []
  }),
  validations () {
    return this.rules
  },
  created () {
    this.fetchData()
  },
  async mounted() {
    await this.$store.dispatch('fetchCurrentUser')
    if(this.user && this.user.roleCoordinator === false && this.user.roleAdmin === false) {
      await this.$router.push(Trans.i18nRoute({
        name: 'error',
        params: {
          status: 403
        }
      }))
    }
    this.breadcrumbs = [
      {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
      {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
      {text: this.$i18n.t('Создание закона'), disabled: true }
    ]
  },
  computed: {
    user() {
      return this.$store.state.getUser.currentUser
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
        this.setLoading(true)
        LAW.getLawData()
          .then((response) => {
            this.lawData = response.data
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Создание Закона
    createLaw () {
      if (!this.validateForm()) {
        return
      }

      this.setLoading(true)
      LAW.createLaw(this.law)
        .then((response) => {
          if (response.status === 201) {
            this.setLoading(false)
            this.$router.push(Trans.i18nRoute({
              name: 'law'
            }))
            // очищаем форму
            this.law = {}
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data.form) {
              this.$noty.error(this.$i18n.t(error.response.data.form.message), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
              this.validateForm()
            } else if (error.response.data.message) {
              this.$noty.error(this.$i18n.t(error.response.data.message), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            } else {
              this.$noty.error(error.message, {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
          } else {
            this.$noty.error(error.message, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          }
          this.setLoading(false)
        })
    },
    // Отмена
    onCancel () {
      this.$router.push(Trans.i18nRoute({
        name: 'law'
      }))
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
